import React, { useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { useSelectedTheme } from "../../../../../../../../Hooks";
import { GetMpiGaugeChartDataAPI } from "../../../../../../../../Services";
import NewGaugeChart from "./NewGaugeChart";

// styles
import useStyles from "./styles";

function NewPropertyMPIGaugeChartComponent({
  unitId,
  marketComparison,
  activeData,
  operationType,
}) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();

  const [chartData, setChartData] = useState({
    minPrice: null,
    maxPrice: null,
    medianPrice: null,
    medianPricePerSqft: null,
    psiPrice: null,
    noMPIDataFoundForTheUnit: null,
  });

  useEffect(() => {
    const GetUnitMpiGaugeChartInfo = async () => {
      if (unitId !== undefined && operationType !== undefined) {
        try {
          const res = await GetMpiGaugeChartDataAPI({
            unitId,
            operationType,
          });
          if (res && (!res.status || res.status === 200)) {
            setChartData({ ...res, noMPIDataFoundForTheUnit: null });
          } else if (res && res.status === 400) {
            setChartData((prev) => ({
              ...prev,
              noMPIDataFoundForTheUnit: res?.data,
            }));
          } else {
            setChartData({
              minPrice: null,
              maxPrice: null,
              medianPrice: null,
              medianPricePerSqft: null,
              psiPrice: null,
              noMPIDataFoundForTheUnit: "Error fetching MPI data.",
            });
          }
        } catch (error) {
          setChartData({
            minPrice: null,
            maxPrice: null,
            medianPrice: null,
            medianPricePerSqft: null,
            psiPrice: null,
            noMPIDataFoundForTheUnit: "Error fetching MPI data.",
          });
        }
      }
    };
    GetUnitMpiGaugeChartInfo();
  }, [unitId, operationType]);

  const shouldShowNoData =
    !activeData?.builtup_area_sqft ||
    activeData.builtup_area_sqft <= 0 ||
    activeData.medianPricePerSqft <= 0;

  return (
    <Box width="100%" mb={5} p={2}>
      {shouldShowNoData ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          py={3}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 600,
              color: palette.primary.main,
              textAlign: "center",
            }}
          >
            No MPI Data Found For The Unit
          </Typography>
        </Box>
      ) : (
        <NewGaugeChart
          activeData={activeData}
          minPrice={chartData?.minPrice || 0}
          maxPrice={chartData?.maxPrice}
          medianPricePerSqft={chartData?.medianPricePerSqft || 0}
          medianPrice={
            chartData?.medianPricePerSqft * activeData.builtup_area_sqft || 0
          }
          marketComparison={marketComparison}
          psiPrice={chartData?.psiPrice || 0}
        />
      )}
    </Box>
  );
}

export default NewPropertyMPIGaugeChartComponent;
